import dayjs from "dayjs";

import type { JobFilters } from "@src/components/FilterJobsControls";

/**
 * Convert JobFilters to API query string
 *
 * Format: "field.OPERATOR:'value' AND field.OPERATOR:'value'"
 *
 * Example output:
 * - "job_type_name.NE:'cache'"
 * - "job_type_name.NE:'cache' AND status_name.EQ:'completed'"
 * - "job_type_name.NE:'cache' AND start_ts.GE:'2024-01-01'"
 */
export const convertFiltersToQuery = (filters: JobFilters): string => {
  const conditions: string[] = [];

  // Hidden job types (NE operator for each hidden type)
  if (filters.hiddenJobTypes.length > 0) {
    const hiddenTypes = filters.hiddenJobTypes;
    hiddenTypes.forEach((type) => {
      conditions.push(`job_type_name.NE:'${type}'`);
    });
  }

  // Status filter (EQ operator)
  if (filters.status) {
    conditions.push(`status_name.EQ:'${filters.status}'`);
  }

  // Worker ID filter (CON operator for partial match)
  if (filters.workerId) {
    conditions.push(`worker_id.CON:'${filters.workerId}'`);
  }

  // Date range filter
  const dateField = filters.dateField;
  if (filters.dateRange.from) {
    const fromDate = dayjs(filters.dateRange.from).format("YYYY-MM-DD");
    conditions.push(`${dateField}.GE:'${fromDate}'`);
  }
  if (filters.dateRange.to) {
    const toDate = dayjs(filters.dateRange.to).format("YYYY-MM-DD");
    conditions.push(`${dateField}.LE:'${toDate}'`);
  }

  // Join with AND
  return conditions.join(" AND ");
};
